import React, { useState } from "react";
import { scaleLinear, format, extent } from "d3";
import "../css/scatterplot.css";
import Dropdown from "../components/Dropdown";


const Scatterplot = ({ plotdata, attributes }) => {
  // console.log("plot data", plotdata);
  
  const circleRadius = 5;
  
  ////////////
  const getLabel = (value) => {
    for (let i = 0; i < attributes.length; i++) {
      if (attributes[i].value === value) {
        return attributes[i].label;
      }
    }
  };
  
  const initialXAttribute = attributes[0].label;
  const [xAttribute, setXAttribute] = useState(initialXAttribute);
  const xValue = (d) => d[xAttribute];
  const xAxisLabel = getLabel(xAttribute);

  const initialYAttribute = attributes[0].label;
  const [yAttribute, setYAttribute] = useState(initialYAttribute);
  const yValue = (d) => d[yAttribute];
  const yAxisLabel = getLabel(yAttribute);
  //////////////////////////////////////////////

  const Marks = ({
    data,
    xScale,
    xValue,
    yScale,
    yValue,
    tooltipFormat,
    circleRadius,
  }) =>
    data.map((d) => (
      <circle
        className="mark"
        cx={xScale(xValue(d))}
        cy={yScale(yValue(d))}
        r={circleRadius}
      >
        <title>{tooltipFormat(xValue(d))}</title>
      </circle>
    ));

  const AxisBottom = ({ xScale, innerHeight, tickFormat, tickOffset = 3 }) =>
    xScale.ticks().map((tickValue) => (
      <g
        className="tick"
        key={tickValue}
        transform={`translate(${xScale(tickValue)},0)`}
      >
        <line y2={innerHeight} />
        <text
          style={{ textAnchor: "middle" }}
          dy=".71em"
          y={innerHeight + tickOffset}
        >
          {tickFormat(tickValue)}
        </text>
      </g>
    ));

  const AxisLeft = ({ yScale, innerWidth, tickOffset = 3 }) =>
    yScale.ticks().map((tickValue) => (
      <g className="tick" transform={`translate(0,${yScale(tickValue)})`}>
        <line x2={innerWidth} />
        <text
          key={tickValue}
          style={{ textAnchor: "end" }}
          x={-tickOffset}
          dy=".32em"
        >
          {tickValue}
        </text>
      </g>
    ));

  const width = 750;
  const height = 450;
  const margin = { top: 20, right: 30, bottom: 65, left: 90 };
  const xAxisLabelOffset = 50;
  const yAxisLabelOffset = 45;
  const innerHeight = height - margin.top - margin.bottom;
  const innerWidth = width - margin.left - margin.right;
  const siFormat = format(".2s");
  const xAxisTickFormat = (tickValue) => siFormat(tickValue).replace("G", "B");

  const xScale = scaleLinear()
    .domain(extent(plotdata, xValue))
    .range([0, innerWidth])
    .nice();

  const yScale = scaleLinear()
    .domain(extent(plotdata, yValue))
    .range([0, innerHeight]);

  return (
    <>
      <div className="col-2">
        <form className="text-center">
          <h4 className="mt-4">X-Axis Columns:</h4>
          <Dropdown
            options={attributes}
            id="x-select"
            selectedValue={xAttribute}
            onSelectedValueChange={setXAttribute}
          />

          <h4 className="mt-4">Y-Axis Columns:</h4>
          <Dropdown
            options={attributes}
            id="y-select"
            selectedValue={yAttribute}
            onSelectedValueChange={setYAttribute}
          />
        </form>
      </div>
      <div className="col-8">
        <svg width={width} height={height}>
          <g transform={`translate(${margin.left}, ${margin.top})`}>
            <AxisBottom
              xScale={xScale}
              innerHeight={innerHeight}
              tickFormat={xAxisTickFormat}
              tickOffset={5}
            ></AxisBottom>
            <text
              className="axis-label"
              textAnchor="middle"
              transform={`translate(${-yAxisLabelOffset},${
                innerHeight / 2
              }) rotate(-90)`}
            >
              {yAxisLabel}
            </text>
            <AxisLeft yScale={yScale} innerWidth={innerWidth} tickOffset={5} />
            <text
              className="axis-label"
              x={innerWidth / 2}
              y={innerHeight + xAxisLabelOffset}
              textAnchor="middle"
            >
              {xAxisLabel}
            </text>
            <Marks
              data={plotdata}
              xScale={xScale}
              xValue={xValue}
              yScale={yScale}
              yValue={yValue}
              tooltipFormat={xAxisTickFormat}
              circleRadius={circleRadius}
            />
          </g>
        </svg>
      </div>
    </>
  );
};

export default Scatterplot;
